import { render } from "./ArtistSvg.vue?vue&type=template&id=1d1e5194"
import script from "./ArtistSvg.vue?vue&type=script&lang=js"
export * from "./ArtistSvg.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__